// File: /src/hooks/useColorManager.js

import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { API_ENDPOINTS } from '../constants/apiEndpoints';
import apiClient from '../services/apiClient';

export const useColorManager = (clients = []) => {
	const [cardColors, setCardColors] = useState({});

	// Inicializar cores a partir dos clientes
	useEffect(() => {
		if (clients && clients.length > 0) {
			const colorsMap = {};
			clients.forEach((client) => {
				if (client.borderColor) {
					colorsMap[client.id] = client.borderColor;
				}
			});
			setCardColors(colorsMap);
		}
	}, [clients]);

	// Função para alterar a cor de um cliente
	const handleColorChange = async (clientId, newColor) => {
		// Só atualiza se receber uma nova cor
		if (!newColor) return;

		const previousColor = cardColors[clientId];

		// Atualiza estado e persiste a cor usando o valor mais recente
		setCardColors((prev) => {
			const next = {
				...prev,
				[clientId]: newColor,
			};
			localStorage.setItem('cardColors', JSON.stringify(next));
			return next;
		});

		try {
			await apiClient.put(
				API_ENDPOINTS.clientColor(clientId),
				{ borderColor: newColor },
				
			);
		} catch (error) {
			console.error('Erro ao salvar a cor no servidor:', error);
			toast.error('Erro ao salvar a cor no servidor.');
			// Reverte para a cor anterior em caso de erro
			setCardColors((prev) => {
				const next = {
					...prev,
					[clientId]: previousColor || '#ccc',
				};
				localStorage.setItem('cardColors', JSON.stringify(next));
				return next;
			});
		}
	};

	return { cardColors, handleColorChange };
};

export default useColorManager;
